import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalQuery } from 'src/Libs/api'
import { getAvailabeAmazonCodeStats } from '../apis'
import { AmazonCodeStatsDto } from '../apis/dto/amazon-codes.dto'

type UseAmazonCodeStats = () => ReturnType<typeof usePortalQuery<AmazonCodeStatsDto>>

/**
 * This hook is responsible of getting the total number of available amazon codes
 */
export const useAvailableAmazonCodeStats: UseAmazonCodeStats = () => {
  const authFetch = useAuthFetchWithResponse()

  const result = usePortalQuery<AmazonCodeStatsDto>({
    queryKey: ['users', 'amazon-codes', 'stats'],
    queryFn: () => getAvailabeAmazonCodeStats(authFetch),
  })

  return result
}
